module.exports = __webpack_public_path__ + "static/media/video-whatis.e1c0d3c0.png";